// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bolt-button-group{gap:8px}", "",{"version":3,"sources":["webpack://./node_modules/azure-devops-ui/Components/ButtonGroup/ButtonGroup.css"],"names":[],"mappings":"AAAA,mBACE,OAAA","sourcesContent":[".bolt-button-group {\n  gap: 8px;\n}\n\n/*# sourceMappingURL=ButtonGroup.css.map */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
